import { render, staticRenderFns } from "./channelsAndAdvertiseTab.vue?vue&type=template&id=40e3ee28&scoped=true"
import script from "./channelsAndAdvertiseTab.vue?vue&type=script&lang=js"
export * from "./channelsAndAdvertiseTab.vue?vue&type=script&lang=js"
import style0 from "./channelsAndAdvertiseTab.vue?vue&type=style&index=0&id=40e3ee28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e3ee28",
  null
  
)

export default component.exports